<script setup lang="ts">
import type { SaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: SaleItemEntity;
}
defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <div v-if="sale.visitorsCount" class="bg-primary-50 rounded-xl px-6 py-2">
        <span>{{ tt('sdp.visitorsCount', { count: sale.visitorsCount }) }}</span>
    </div>
</template>
